// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {


    //　メインビジュアルスライダー
    // ================================= 
    const mainvisualSlide = new Swiper('.js-mainvisual-slider', {
        //オートプレイ
        autoplay: {
          delay: 3000,
        },
        //無限ループ
        loop: true,
        speed: 1500,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
    });

    //　メンバースライダー
    // =================================
    const memberSlide = new Swiper('.js-member-slider', {
        //オートプレイ
        autoplay: {
          delay: 2000,
        },
    
        //無限ループ
        loop: true,
        slidesPerView: 1.4,
        grabCursor: true,
        centeredSlides: true,
        spaceBetween: 30,
        speed: 1500,
        breakpoints: {
            768: {
                slidesPerView: 4.6,
            },
        }
    });


    //　ハンバーガーメニュー
    // =================================
    const menuBtn = document.querySelector('.js-mobile-menu');
    const nav     = document.querySelector('.site-navigation');
    if (!menuBtn || !nav) return;

    menuBtn.addEventListener('click', function() {
      menuBtn.classList.toggle('is-active');
      nav.classList.toggle('is-active');

      if (menuBtn.classList.contains('is-active')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });

    document.querySelectorAll('.site-navigation-list__link').forEach(function(link) {
      link.addEventListener('click', function() {
        menuBtn.classList.remove('is-active');
        nav.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    });


    // ページスクロール
    // =================================
    const pageTop = document.querySelector('.js-page-top');
    if (!pageTop) return;

    pageTop.addEventListener('click', function(e) {
      e.preventDefault(); // aタグの場合のデフォルト動作防止
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });


    // ヘッダーのスクロール中の挙動
    // =================================
    const header = document.querySelector('.site-header');
    let scrollTimer = null;

    window.addEventListener('scroll', () => {
      header.classList.add('is-hide');
      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        header.classList.remove('is-hide');
      }, 200);
    });

    // Aboutページの画像スクロールの位置を調整
    // =================================
    const container = document.querySelector('.about-section-01-img');
    container.scrollLeft = (container.scrollWidth - container.clientWidth) / 2;

    const hint = container.querySelector('.scroll-hint');
    let scrollTimeout;

    container.addEventListener('scroll', () => {
      // スクロール中はメッセージ非表示
      hint.style.opacity = '0';

      // タイマーリセット
      if (scrollTimeout) clearTimeout(scrollTimeout);

      // 5秒後にメッセージを再表示
      scrollTimeout = setTimeout(() => {
        hint.style.opacity = '1';
      }, 5000);
    });
});






